import { AppContextualMenu } from "@1js/acui-menu";

import {
  AppFlyoutAnchorProps,
  AppFlyoutAnchorState,
  AppMenuButtonProps,
} from "./AppFlyoutAnchor.types";
import { useAppFlyoutAnchorState } from "./useAppFlyoutAnchorState";
import { AppMenuButton } from ".";
import { resolveShorthand } from "@fluentui/react-utilities";

export const useAppFlyoutAnchor = (
  props: AppFlyoutAnchorProps,
  ref: React.Ref<HTMLButtonElement>
): AppFlyoutAnchorState => {
  const { persistMenu, shadowRenderMenu } = props;
  const defaultMenuButtonProps = {
    ...props,
    ref,
  } as AppMenuButtonProps;
  const defaultMenuItems = { items: [] };

  const state: AppFlyoutAnchorState = {
    persistMenu,
    shadowRenderMenu,

    components: {
      menuButton: AppMenuButton,
      menu: AppContextualMenu,
    },

    menu:
      resolveShorthand(props.menu, { defaultProps: defaultMenuItems }) ||
      defaultMenuItems,
    menuButton:
      resolveShorthand(props.menuButton, {
        defaultProps: defaultMenuButtonProps,
      }) || defaultMenuButtonProps,
  };

  return useAppFlyoutAnchorState(props, state);
};
